import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CourseState } from '../reducers/course.reducer';
import { COURSE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<CourseState>(COURSE_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: CourseState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectState, (state: CourseState) => (state.items[id] ? state.items[id].loading : false));
export const selectCourse = (id: string) => createSelector(selectState, (state: CourseState) => (state.items[id] ? state.items[id].data : null));
export const selectCourseAccess = (id: string) => createSelector(selectCourse(id), (course) => course?.access ?? true);
